import { render, staticRenderFns } from "./WebViewerROC.vue?vue&type=template&id=21115fda"
import script from "./WebViewerROC.vue?vue&type=script&lang=js"
export * from "./WebViewerROC.vue?vue&type=script&lang=js"
import style0 from "./WebViewerROC.vue?vue&type=style&index=0&id=21115fda&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports